import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

// components
import Header from '../../components/Header/Header';
import HookForm from '../../components/HookForm/HookForm';
import Breadcrumbs from '../../components/Breadcrumbs';
import Loader from '../../components/Loader/Loader';
import SelectClients from '../../components/Selects/SelectClients';
import SelectServiceStatuses from '../../components/Selects/SelectServiceStatuses';
import SelectSources from '../../components/Selects/SelectSources';
import SelectServiceAddress from '../../components/Selects/SelectServiceAddress';
import SelectManagers from '../../components/Selects/SelectManagers';
import Datepicker from '../../components/Inputs/Datepicker/Datepicker';
import Select from '../../components/Select/Select';
import getServiceRecords from '../../api/services/getServiceRecords';
import editServiceRecord from '../../api/services/editServiceRecord';
import alert from '../../helpers/alert';
import { timeOfRecord, datePickerValue, dayString } from '../../utils/recordDate';

// icons
import icon from '../../brand/generated/sidebar/records.svg';

const formStyles = {
  record: {
    display: 'grid',
    gap: '20px',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gridTemplateAreas: `'a a k k' 'b b b b' 'c c c c' 'd d n n' 'f f f f'`,
  },
  // Ð ÑÐ´ Ð¿Ð¾Ð´ ÑÐ°Ð»Ð¾Ð½ ÑÑÐ°ÑÑÑ Ð·Ð°Ð¿Ð¸ÑÐµÐ¹: Ñ Ð½Ð¾Ð²ÑÑ ÐµÐ³Ð¾ Ð½ÐµÑ, Ð¸ Ð»Ð¸ÑÐ½ÑÑ Ð¿ÑÑÑÐ°Ñ ÑÑÑÐ¾ÐºÐ°
  // Ð² ÑÐµÑÐºÐµ Ð½Ðµ Ð½ÑÐ¶Ð½Ð°.
  legacyDc: {
    display: 'grid',
    gap: '20px',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gridTemplateAreas: `'a a k k' 'b b b b' 'c c c c' 'd d n n' 'e e e e' 'f f f f'`,
  },
};

const baseTimeOptions = [
  { value: '09:00', label: '09:00' },
  { value: '10:30', label: '10:30' },
  { value: '12:00', label: '12:00' },
  { value: '13:30', label: '13:30' },
  { value: '15:00', label: '15:00' },
  { value: '16:30', label: '16:30' },
];

const RecordService = () => {
  const { id } = useParams();
  const [pageLoading, setPageLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [editable, setEditable] = useState(false);
  const [record, setRecord] = useState(null);

  const fetchRecord = () =>
    getServiceRecords({ id }).then((res) => setRecord(res?.data?.services?.[0] ?? null));

  useEffect(() => {
    fetchRecord().finally(() => setPageLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  if (pageLoading) return <Loader />;

  const recordTime = timeOfRecord(record?.date);
  const servicesTitle = (record?.valuesToServices || []).map((item) => item.title).join(', ');
  // Ð¢Ð¾ÑÐºÐ¸ ÑÐµÑÑ-Ð´ÑÐ°Ð¹Ð²Ð° Ð¸ ÑÐµÑÐ²Ð¸ÑÐ½ÑÐµ ÑÐ¾ÑÐºÐ¸ â Ð¾Ð´Ð¸Ð½ ÑÐ¿ÑÐ°Ð²Ð¾ÑÐ½Ð¸Ðº, Ð½Ð¾ ÑÐ°Ð·Ð½ÑÐµ ÑÑÑÐ¾ÐºÐ¸:
  // ÑÐ¸Ð¿ Ð·Ð°Ð¿Ð¸ÑÐ¸ Ð²ÑÐ±Ð¸ÑÐ°ÐµÑ, Ð¸Ð· ÑÐµÐ³Ð¾ Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÑÑ ÑÐ¿Ð¸ÑÐ¾Ðº Ð¸ ÑÐ¸Ð»ÑÑÑÐ¾Ð²Ð°ÑÑ Ð»Ð¸ Ð¿Ð¾ Ð¼Ð°ÑÐºÐµ.
  const isTestDrive = record?.type?.id === 1;
  const timeOptions =
    !recordTime || baseTimeOptions.some((o) => o.value === recordTime)
      ? baseTimeOptions
      : [...baseTimeOptions, { value: recordTime, label: recordTime }];

  const editRecord = (data) => {
    setSaving(true);
    const day = dayString(data?.created_at);
    const time = data?.time?.value;
    const payload = {
      id: Number(id),
      typeId: record?.type?.id,
      date: day + ' ' + time + ':00',
      userId: data?.userId?.value,
      statusId: data?.statuse?.value,
      sourceId: data?.sourceId?.value,
      dealerAddressId: data?.dealerAddressId?.value,
      managerId: data?.managerId?.value,
      comment: data?.comment,
    };

    editServiceRecord(payload)
      .then(() => fetchRecord())
      .then(() => setEditable(false))
      .catch((error) => alert.error(error?.response?.data?.errorMessage ?? JSON.stringify(error?.response)))
      .finally(() => setSaving(false));
  };

  // ÐÐ½Ð¿ÑÑÑ Ð´ÐµÑÐ¶Ð°Ñ defaultValue Ð¸Ð· ÑÐ¶Ðµ Ð·Ð°Ð³ÑÑÐ¶ÐµÐ½Ð½Ð¾Ð¹ Ð·Ð°Ð¿Ð¸ÑÐ¸ â react-hook-form
  // ÑÐ¸ÐºÑÐ¸ÑÑÐµÑ Ð¸Ñ Ð¾Ð´Ð¸Ð½ ÑÐ°Ð· Ð¿ÑÐ¸ Ð¼Ð¾Ð½ÑÐ¸ÑÐ¾Ð²Ð°Ð½Ð¸Ð¸ HookForm, Ð¿Ð¾ÑÑÐ¾Ð¼Ñ ÑÐµÐ½Ð´ÐµÑÐ¸Ð¼ ÑÐ¾ÑÐ¼Ñ
  // ÑÐ¾Ð»ÑÐºÐ¾ Ð¿Ð¾ÑÐ»Ðµ ÑÐ¾Ð³Ð¾ ÐºÐ°Ðº record Ð³Ð°ÑÐ°Ð½ÑÐ¸ÑÐ¾Ð²Ð°Ð½Ð½Ð¾ Ð·Ð°Ð³ÑÑÐ¶ÐµÐ½ (ÑÐ¼. pageLoading Ð²ÑÑÐµ)
  const inputs = [
    {
      name: 'userId',
      component: SelectClients,
      label: 'ÐÐ»Ð¸ÐµÐ½Ñ',
      placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°',
      style: { gridArea: 'k' },
      defaultValue: record ? { value: record.id, label: `${record.fio} ${record.phone}`.trim() } : undefined,
      disabled: !editable,
      rules: { required: true },
    },
    {
      name: 'statuse',
      component: SelectServiceStatuses,
      label: 'Ð¡ÑÐ°ÑÑÑ Ð·Ð°Ð¿Ð¸ÑÐ¸',
      placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°',
      defaultValue: record?.status ? { value: record.status.id, label: record.status.title } : undefined,
      disabled: !editable,
      rules: { required: true },
    },
    {
      name: 'sourceId',
      component: SelectSources,
      label: 'ÐÑÑÐ¾ÑÐ½Ð¸Ðº',
      placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°',
      defaultValue: record?.source ? { value: record.source.id, label: record.source.title } : undefined,
      disabled: !editable,
      rules: { required: true },
    },
    {
      name: 'created_at',
      type: 'date',
      component: Datepicker,
      label: 'ÐÐ°ÑÐ°',
      defaultValue: datePickerValue(record?.date),
      disabled: !editable,
      rules: { required: true },
    },
    {
      name: 'time',
      component: Select,
      label: 'ÐÑÐµÐ¼Ñ',
      placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°',
      options: timeOptions,
      defaultValue: recordTime ? { value: recordTime, label: recordTime } : undefined,
      disabled: !editable,
      rules: { required: true },
    },
    isTestDrive
      ? {
          name: 'car',
          type: 'input',
          label: 'ÐÐ²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ',
          style: { gridArea: 'c' },
          defaultValue: [record?.mark?.name, record?.model?.name].filter(Boolean).join(' '),
          disabled: true,
        }
      : {
          name: 'services',
          type: 'input',
          label: 'Ð£ÑÐ»ÑÐ³Ð°',
          style: { gridArea: 'c' },
          defaultValue: servicesTitle,
          disabled: true,
        },
    {
      name: 'dealerAddressId',
      component: SelectServiceAddress,
      // ÐÐ»Ñ ÑÐµÑÑ-Ð´ÑÐ°Ð¹Ð²Ð° â ÑÐ¾ÑÐºÐ¸ ÑÐµÑÑ-Ð´ÑÐ°Ð¹Ð²Ð°, Ð¸ ÑÐ¾Ð»ÑÐºÐ¾ ÑÐµ, Ð³Ð´Ðµ Ð¼Ð°ÑÐºÑ Ð·Ð°Ð¿Ð¸ÑÐ¸
      // Ð´Ð°ÑÑ Ð¿Ð¾ÐºÐ°ÑÐ°ÑÑ; Ð´Ð»Ñ ÑÐµÑÐ²Ð¸ÑÐ° â ÑÐµÑÐ²Ð¸ÑÐ½ÑÐµ, Ð±ÐµÐ· ÑÐ¸Ð»ÑÑÑÐ° Ð¿Ð¾ Ð¼Ð°ÑÐºÐµ.
      typeId: isTestDrive ? 1 : 3,
      markId: isTestDrive ? record?.mark?.id : undefined,
      label: isTestDrive ? 'ÐÐ´ÑÐµÑ ÑÐµÑÑ-Ð´ÑÐ°Ð¹Ð²Ð°' : 'ÐÐ´ÑÐµÑ ÑÐµÑÐ²Ð¸ÑÐ°',
      placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°',
      style: { gridArea: 'n' },
      defaultValue: record?.dealerAddressId
        ? { value: record.dealerAddressId, label: record.dealerAddress }
        : undefined,
      disabled: !editable,
    },
    // Ð¡Ð°Ð»Ð¾Ð½ Ð·Ð°Ð¿Ð¸ÑÐµÐ¹, ÑÐ¾Ð·Ð´Ð°Ð½Ð½ÑÑ Ð´Ð¾ ÑÐ¿ÑÐ°Ð²Ð¾ÑÐ½Ð¸ÐºÐ° ÑÐ¾ÑÐµÐº ÑÐµÑÑ-Ð´ÑÐ°Ð¹Ð²Ð°. Ð¢Ð¾Ð»ÑÐºÐ¾
    // Ð¿Ð¾ÐºÐ°Ð·Ð°ÑÑ: Ð²ÑÐ±Ð¸ÑÐ°ÑÑ ÐÐ¦ Ð±Ð¾Ð»ÑÑÐµ Ð½ÐµÐ³Ð´Ðµ, Ð° ÑÐµÑÑÑÑ ÑÐ¾, ÑÑÐ¾ Ð²ÑÐ±ÑÐ°Ð» Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑ,
    // Ð½ÐµÐ»ÑÐ·Ñ.
    ...(record?.dcId
      ? [
          {
            name: 'dcName',
            type: 'input',
            label: 'Ð¡Ð°Ð»Ð¾Ð½ ÑÐµÑÑ-Ð´ÑÐ°Ð¹Ð²Ð° (ÑÑÐ°ÑÐ°Ñ Ð·Ð°Ð¿Ð¸ÑÑ)',
            style: { gridArea: 'e' },
            defaultValue: record?.dcName,
            disabled: true,
          },
        ]
      : []),
    {
      name: 'managerId',
      component: SelectManagers,
      label: 'ÐÑÐ²ÐµÑÑÑÐ²ÐµÐ½Ð½ÑÐ¹ Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑ',
      placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°',
      style: { gridArea: 'd' },
      defaultValue: record?.managerId ? { value: record.managerId, label: record.managerFio } : undefined,
      disabled: !editable,
    },
    {
      name: 'comment',
      type: 'input',
      label: 'ÐÐ°Ð¼ÐµÑÐºÐ¸/ÐºÐ¾Ð¼Ð¼ÐµÐ½ÑÐ°ÑÐ¸Ð¸ Ð¾ Ð·Ð°Ð¿Ð¸ÑÐ¸',
      placeholder: 'ÐÑÑÐ°Ð²ÑÑÐµ Ð²Ð°Ñ ÐºÐ¾Ð¼Ð¼ÐµÐ½ÑÐ°ÑÐ¸Ð¹',
      style: { gridArea: 'f' },
      defaultValue: record?.comment,
      disabled: !editable,
    },
  ];

  return (
    <div style={{ paddingBottom: '20px' }}>
      {saving && <Loader />}
      <Header title={`ÐÐ°Ð¿Ð¸ÑÑ ID ${id}`} icon={icon} />
      <Breadcrumbs navigate={'/records'} link={'ÐÐ°Ð¿Ð¸ÑÐ¸'} currentPage={`ÐÐ°Ð¿Ð¸ÑÑ ID ${id}`} />
      <HookForm
        inputs={inputs}
        title={'ÐÐ½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ Ð¾ Ð·Ð°Ð¿Ð¸ÑÐ¸'}
        grid={record?.dcId ? formStyles.legacyDc : formStyles.record}
        border
        edit={!editable}
        handleFormEdit={() => setEditable(true)}
        action={editable ? 'Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑ' : undefined}
        onSubmit={editRecord}
      />
    </div>
  );
};

export default RecordService;
